/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from "react-bootstrap";
import L from "./Lang"
import BaseCom from "./BaseCom";
import FormInput from "./FormInput";
import { qreq } from "../shared/qrequest";
import Icon from "./Icon";

export default class MedicalReleaseSendModal extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {},
            showSendModal: false
        };
        this.submit = this.submit.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.show !== prevProps.show) {
            this.setState({ info: { ...this.state.info, emails: this.props.emails } });
        }
    }

    submit(e) {
        if (e) e.preventDefault();
        this.setState({ submitting: true });
        qreq.post('/api/document/medical-release/send', { ...this.state.info, orderID: this.props.orderID }, j => {
            if (j.errorCode === 0) {
                this.success('Medical Release sent successfully.');
                this.props.onHide();
            }
            else
                this.alert(j.errorMessage);
            this.setState({ submitting: false });
        }, () => {
            this.setState({ submitting: false });
            this.unkownErrorCallback();
        });
    }

    render() {
        if (!this.props.show) return;
        return <Modal show={this.props.show} onHide={this.props.onHide}>
            <Modal.Header closeButton><L>Medical Release</L></Modal.Header>
            <form onSubmit={this.submit}>
                <Modal.Body>
                    <FormInput model={this.state.info} name="emails" label="Emails" type="text" required placeholder="Comma ',' separated recipient emails..." />
                    <FormInput model={this.state.info} name="sendPhone" label="Text to Phone (Optional)" type="text" placeholder="Only 1 phone number allowed at a time." />
                </Modal.Body>
                <Modal.Footer>
                    <button type="submit" className="btn btn-success" disabled={this.state.submitting}><Icon icon="faPaperPlane" /> <L>Send</L></button>
                    <button type="button" className="btn btn-secondary" onClick={this.props.onHide}><Icon icon="faCancel" /> <L>Cancel</L></button>
                </Modal.Footer>
            </form>
        </Modal>;
    }
}